// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `offline .projectCheck {
  margin-top: 10px;
  height: 28px;
  padding: 2px;
}
offline .offline-div.available {
  display: inline-block;
  width: 200px;
  margin-top: 0px;
  height: 20px;
}
offline .offline-switch {
  margin-left: 0px;
}
offline .offline-div {
  text-align: center;
  width: 200px;
  margin: auto;
  margin-top: 20px;
}
offline .offline-label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.9em;
}
offline .offline-size {
  padding: 6px;
}
offline .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin: auto;
  margin-top: 6px;
}
offline .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
offline .check-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999999;
  transition: 0.4s;
  border-radius: 34px;
}
offline .check-slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
offline input:checked + .check-slider.ongoing {
  background-color: var(--motes-gold);
}
offline input:checked + .check-slider.cached {
  background-color: var(--motes-green);
}
offline input:checked + .check-slider:before {
  transform: translateX(26px);
}
offline .progress-container {
  width: 88%;
  font-size: 0.8em;
  margin: auto;
  opacity: 0;
  margin-top: 20px;
}
offline .progress-status {
  text-align: center;
}
offline .show-progress {
  opacity: 1;
}
offline .show-progress progress[value]::-webkit-progress-value {
  background-color: var(--motes-gold);
}
offline .ongoing progress[value]::-webkit-progress-value {
  transition-delay: 16s;
  -webkit-transition: background-color 12s;
  transition: background-color 12s;
  background-color: var(--motes-green-dark);
}
offline .hide-progress {
  opacity: 0;
  transition: 250ms ease-out;
  transition-delay: 2s;
}
offline progress {
  background-color: #f3f3f3;
  border: 0;
  height: 18px;
  border-radius: 40%;
  width: 100%;
  height: 2px;
  margin-top: 10px;
  margin-bottom: 6px;
}
offline .error-msg {
  margin-top: 2px;
  border-radius: 4px;
  margin-top: 8px;
  font-weight: bold;
  margin-bottom: -13px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/offline/offline-components/offline.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,YAAA;EACA,YAAA;AAAR;AAGI;EACI,qBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AADR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAHR;AAMI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AAOI;EACI,YAAA;AALR;AASI;EACI,kBAAA;EACA,qBAAA;EACA,WAJW;EAKX,YAAA;EACA,YAAA;EACA,eAAA;AAPR;AAUI;EACI,UAAA;EACA,QAAA;EACA,SAAA;AARR;AAWI;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;EACA,mBAAA;AATR;AAYI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;EACA,kBAAA;AAVR;AAaI;EACI,mCAAA;AAXR;AAeI;EACI,oCAAA;AAbR;AAoBI;EAGI,2BAAA;AAlBR;AAqBI;EACI,UAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,kBAAA;AApBR;AAuBI;EACI,UAAA;AArBR;AAsBQ;EACI,mCAAA;AApBZ;AAyBQ;EACI,qBAAA;EACA,wCAAA;EAAA,gCAAA;EACA,yCAAA;AAvBZ;AA2BI;EACI,UAAA;EACA,0BAAA;EACA,oBAAA;AAzBR;AA4BI;EACI,yBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA1BR;AA6BI;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;AA3BR","sourcesContent":["offline {\n    .projectCheck {\n        margin-top: 10px;\n        height: 28px;\n        padding: 2px;\n    }\n\n    .offline-div.available {\n        display: inline-block;\n        width: 200px;\n        margin-top: 0px;\n        height: 20px;\n    }\n\n    .offline-switch {\n        margin-left: 0px;\n    }\n\n    .offline-div {\n        text-align: center;\n        width: 200px;\n        margin: auto;\n        margin-top: 20px;\n    }\n\n    .offline-label {\n        display: block;\n        margin-bottom: 5px;\n        font-size: 0.9em;\n    }\n\n    .offline-size {\n        padding: 6px;\n    }\n\n    $switch-width: 60px;\n    .switch {\n        position: relative;\n        display: inline-block;\n        width: $switch-width;\n        height: 34px;\n        margin: auto;\n        margin-top: 6px;\n    }\n\n    .switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .check-slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #999999;\n        -webkit-transition: .4s;\n        transition: .4s;\n        border-radius: 34px;\n    }\n\n    .check-slider:before {\n        position: absolute;\n        content: \"\";\n        height: 26px;\n        width: 26px;\n        left: 4px;\n        bottom: 4px;\n        background-color: white;\n        -webkit-transition: .4s;\n        transition: .4s;\n        border-radius: 50%;\n    }\n\n    input:checked + .check-slider.ongoing {\n        background-color: var(--motes-gold);\n        // background-color: var(--motes-orange);\n    }\n\n    input:checked + .check-slider.cached {\n        background-color: var(--motes-green);\n    }\n\n    input:focus + .check-slider {\n        // background-color: var(--motes-orange);\n    }\n\n    input:checked + .check-slider:before {\n        -webkit-transform: translateX($switch-width - 34px);\n        -ms-transform: translateX($switch-width - 34px);\n        transform: translateX($switch-width - 34px);\n    }\n\n    .progress-container  {\n        width: 88%;\n        font-size: 0.8em;\n        margin: auto;\n        opacity:0;\n        margin-top: 20px;\n    }\n\n    .progress-status {\n        text-align: center;\n    }\n\n    .show-progress {\n        opacity: 1;\n        progress[value]::-webkit-progress-value {\n            background-color: var(--motes-gold);\n        }\n    }\n\n    .ongoing {\n        progress[value]::-webkit-progress-value {\n            transition-delay: 16s;\n            transition: background-color 12s;\n            background-color: var(--motes-green-dark);\n        }\n    }\n\n    .hide-progress {\n        opacity: 0;\n        transition: 250ms ease-out;\n        transition-delay: 2s;\n    }\n\n    progress {\n        background-color: #f3f3f3;\n        border: 0;\n        height: 18px;\n        border-radius: 40%;\n        width: 100%;\n        height: 2px;\n        margin-top: 10px;\n        margin-bottom: 6px;\n    }\n\n    .error-msg {\n        margin-top: 2px;\n        border-radius: 4px;\n        margin-top: 8px;\n        font-weight: bold;\n        margin-bottom: -13px;\n        color: white;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
